export default "__VITE_ASSET__ef10f05c__"